(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luma-mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
  const getPandectesMobileOffset = () =>
    document.querySelector('#Details-menu-drawer-container[open]') ? '140px' : '78px';

  const applyPandectesMobileOffset = () => {
    const pandectes = document.querySelector('pandectes-cmp');

    if (!pandectes?.shadowRoot) return false;

    let style = pandectes.shadowRoot.querySelector('[data-luma-mobile-offset]');
    if (!style) {
      style = document.createElement('style');
      style.dataset.lumaMobileOffset = '';
      style.textContent =
        '@media (max-width: 749px) { button.widget.bottom { bottom: var(--luma-cookie-widget-bottom, 78px) !important; } }';
      pandectes.shadowRoot.appendChild(style);
    }

    pandectes.style.setProperty('--luma-cookie-widget-bottom', getPandectesMobileOffset());

    return true;
  };

  if (!applyPandectesMobileOffset()) {
    const pandectesObserver = new MutationObserver(() => {
      if (applyPandectesMobileOffset()) pandectesObserver.disconnect();
    });

    pandectesObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => pandectesObserver.disconnect(), 10000);
  }

  const mobileDrawer = document.querySelector('#Details-menu-drawer-container');
  if (mobileDrawer) {
    const mobileDrawerObserver = new MutationObserver(() => applyPandectesMobileOffset());
    mobileDrawerObserver.observe(mobileDrawer, {
      attributes: true,
      attributeFilter: ['open', 'class'],
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
